import React, { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

const ExternalLogin = () => {

  const { instance } = useMsal();
  const loginStarted = useRef(false);

  useEffect(() => {

    if (loginStarted.current) return;

    loginStarted.current = true;

    instance.loginRedirect(loginRequest).catch((error) => {
      console.error("loginRedirect failed:", error);
      loginStarted.current = false;
    });
  }, [instance]);

  return <div style={{ color: "white" }}>Redirecting ...</div>;
};

export default ExternalLogin;